import type { SVGProps } from "react";

export default function DataContentIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.6667 11.6667C17.5872 11.6667 18.3333 10.9205 18.3333 9.99999C18.3333 9.07949 17.5872 8.33333 16.6667 8.33333C15.7462 8.33333 15 9.07949 15 9.99999C15 10.9205 15.7462 11.6667 16.6667 11.6667Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6667 5C17.5872 5 18.3333 4.25381 18.3333 3.33334C18.3333 2.41286 17.5872 1.66667 16.6667 1.66667C15.7462 1.66667 15 2.41286 15 3.33334C15 4.25381 15.7462 5 16.6667 5Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6667 18.3333C17.5872 18.3333 18.3333 17.5872 18.3333 16.6667C18.3333 15.7462 17.5872 15 16.6667 15C15.7462 15 15 15.7462 15 16.6667C15 17.5872 15.7462 18.3333 16.6667 18.3333Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33366 11.6667C4.25413 11.6667 5.00033 10.9205 5.00033 9.99999C5.00033 9.07949 4.25413 8.33333 3.33366 8.33333C2.41318 8.33333 1.66699 9.07949 1.66699 9.99999C1.66699 10.9205 2.41318 11.6667 3.33366 11.6667Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 10.0001H15"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0003 3.3334H11.667C10.0003 3.3334 9.16699 4.16674 9.16699 5.8334V14.1667C9.16699 15.8334 10.0003 16.6667 11.667 16.6667H15.0003"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
